// extracted by mini-css-extract-plugin
export default {"block":"page-not-found_block__l02zB","title":"page-not-found_title__fPK4Q","subtitle":"page-not-found_subtitle__nYBqt","link":"page-not-found_link__htSJG"};